import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyAWC1pO2r4oyZB2mXrOcprt8WMnHhz0K-8',
  authDomain: 'thinqwith.firebaseapp.com',
  projectId: 'thinqwith',
  storageBucket: 'thinqwith.firebasestorage.app',
  messagingSenderId: '518730117909',
  appId: '1:518730117909:web:85cce4ba6ec6daad512f1c',
  measurementId: 'G-C05XR3PDKV',
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const Analytics = {
  // ── Identity ──────────────────────────────────────────────────────────────
  // Call once per session after auth resolves. Enables GA4 User Explorer so
  // you can look up any individual by their Firebase UID.
  identifyUser: (uid, { plan = 'free', handle = null } = {}) => {
    setUserId(analytics, uid);
    setUserProperties(analytics, {
      plan,                          // 'free' | 'pro'
      has_handle: handle ? 'yes' : 'no',
    });
  },

  // ── Page views ────────────────────────────────────────────────────────────
  trackPageView: (name) => logEvent(analytics, 'page_view', { page_title: name }),

  // ── Auth ──────────────────────────────────────────────────────────────────
  trackSignIn: (method) => logEvent(analytics, 'login', { method }),
  trackSignUp: (method) => logEvent(analytics, 'sign_up', { method }),

  // ── Creator actions ───────────────────────────────────────────────────────
  trackCardGenerate: () => logEvent(analytics, 'card_generate'),
  trackCardPublish: (cardId) => logEvent(analytics, 'card_publish', { card_id: cardId }),
  trackProfileUpdated: () => logEvent(analytics, 'profile_updated'),

  // ── Billing ───────────────────────────────────────────────────────────────
  trackUpgradeClick: (location) => logEvent(analytics, 'upgrade_click', { location }),
  trackCheckoutStarted: () => logEvent(analytics, 'begin_checkout'),

  // ── Reader actions ────────────────────────────────────────────────────────
  trackCardView: (cardId, creatorId) =>
    logEvent(analytics, 'card_view', { card_id: cardId, creator_id: creatorId }),
  trackProfileView: (username) =>
    logEvent(analytics, 'profile_view', { username }),
  trackPlatformModal: (vectorId) =>
    logEvent(analytics, 'platform_modal_open', { vector_id: vectorId }),
  trackVectorLaunch: (vectorId, platform) =>
    logEvent(analytics, 'vector_launch', { vector_id: vectorId, platform }),
  trackBookmark: (cardId) =>
    logEvent(analytics, 'bookmark_card', { card_id: cardId }),
  trackFollow: (creatorId) =>
    logEvent(analytics, 'follow_creator', { creator_id: creatorId }),
  trackObservation: (cardId, vectorId) =>
    logEvent(analytics, 'save_observation', { card_id: cardId, vector_id: vectorId }),

  // ── Errors ────────────────────────────────────────────────────────────────
  trackError: (msg, ctx) =>
    logEvent(analytics, 'error', { error_message: msg, context: ctx }),
};

export { app, analytics };
